import { visitarPágina } from '@App/Reflinks'

/**
 * A última notificação ativa que está sendo mostrada.
 */
let notificaçãoAtiva = null

export function notificar({ title, body, icon, url }) {
    if (notificaçãoAtiva) notificaçãoAtiva.close()

    // Let's check if the browser supports notifications
    if (!('Notification' in window)) {
        return
    } else if (Notification.permission === 'granted') {
        // If it's okay let's create a notification
        notificaçãoAtiva = new Notification(title, { body, icon })
        setTimeout(notificaçãoAtiva.close.bind(notificaçãoAtiva), 5000)

        notificaçãoAtiva.addEventListener('click', () => {
            notificaçãoAtiva.close()
            notificaçãoAtiva = null

            window.focus()

            if (url) visitarPágina(url)
        })
    } else if (Notification.permission !== 'denied') {
        Notification.requestPermission(permission => {
            // If the user accepts, let's create a notification
            if (permission === 'granted') {
                notificaçãoAtiva = new Notification(title, { body, icon })
                setTimeout(notificaçãoAtiva.close.bind(notificaçãoAtiva), 5000)

                notificaçãoAtiva.addEventListener('click', () => {
                    notificaçãoAtiva.close()
                    notificaçãoAtiva = null

                    window.focus()

                    if (url) visitarPágina(url)
                })
            }
        })
    }

    // Finally, if the user has denied notifications and you
    // want to be respectful there is no need to bother them any more.
}
